import { render, staticRenderFns } from "./TypeJobSearchAssistanceList.vue?vue&type=template&id=d20b6f04&"
import script from "./TypeJobSearchAssistanceList.vue?vue&type=script&lang=js&"
export * from "./TypeJobSearchAssistanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports